export default __webpack_public_path__ + "static/media/LOGO_MEDIUM_WHITE.0c40025b.svg";